import SubscriptionRewardStructure from '@/datatypes/promocode/reward-structure/subscription';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default class PromocodeRewardStructure {
  public kind: number;
  public payg: boolean;
  public subscription;

  constructor(options) {
    this.kind = options.kind;
    this.payg = options.payg;
    if (options.subscription) {
      this.subscription = new SubscriptionRewardStructure(camelcaseKeysDeep(options.subscription));
    }
  }
}
